import { getHostElement } from '../consumer/consumes-decorator';
export function Provides(context) {
  return (target, propertyKey) => {
    const contextKey = context !== null && context !== void 0 ? context : propertyKey;
    target.__syContextProvidesKeys = target.__syContextProvidesKeys || [];
    if (!target.__syContextProvidesKeys.find(el => el.contextKey == contextKey)) {
      target.__syContextProvidesKeys.push({ contextKey, propertyKey });
    }
    // Define property watcher
    const watcherPropertyKey = `__syContext_${propertyKey}Watcher`;
    Object.defineProperty(target, watcherPropertyKey, {
      value: function () {
        if (!this.__syConsumersMap.has(contextKey)) {
          this.__syConsumersMap.set(contextKey, new Set());
        }
        const consumersSet = this.__syConsumersMap.get(contextKey);
        consumersSet.forEach(el => {
          el.changeValue(this[propertyKey]);
        });
      },
    });
    const { watchers } = target.constructor;
    Object.defineProperty(target.constructor, 'watchers', {
      get: function () {
        var _a;
        const obj = Object.assign({}, watchers !== null && watchers !== void 0 ? watchers : {});
        obj[propertyKey] = (_a = obj[propertyKey]) !== null && _a !== void 0 ? _a : [];
        obj[propertyKey].push(watcherPropertyKey);
        return obj;
      },
      configurable: true,
    });
    if (target.__syContextProvidesWrapped)
      return;
    target.__syContextProvidesWrapped = true;
    const { connectedCallback, disconnectedCallback } = target;
    target.connectedCallback = async function () {
      var _a;
      this.__syConsumersMap = (_a = this.__syConsumersMap) !== null && _a !== void 0 ? _a : new Map();
      const connectCallbackReturn = connectedCallback && connectedCallback.call(this);
      const element = getHostElement(this);
      this.__syContextProvidesListeningFunction = (e) => {
        const { context } = e === null || e === void 0 ? void 0 : e.detail;
        const providerKey = target.__syContextProvidesKeys.find(key => key.contextKey == context);
        // Not for this provider
        if (!providerKey)
          return;
        if (!this.__syConsumersMap.has(context)) {
          this.__syConsumersMap.set(context, new Set());
        }
        const consumersSet = this.__syConsumersMap.get(context);
        if (e.detail.el && !e.detail.el.unsubscribe) {
          consumersSet.add(e.detail.el);
          e.detail.el.changeValue(this[providerKey.propertyKey]);
          e.detail.el.unsubscribe = () => {
            consumersSet.delete(e.detail.el);
            e.detail.el.unsubscribe = null;
          };
          e.stopPropagation();
        }
      };
      element === null || element === void 0 ? void 0 : element.addEventListener('syContextConsumerDidSubscribe', this.__syContextProvidesListeningFunction);
      return connectCallbackReturn;
    };
    target.disconnectedCallback = async function () {
      const disconnectedCallbackReturn = disconnectedCallback && disconnectedCallback.call(this);
      if (this.__syContextProvidesListeningFunction) {
        const element = getHostElement(this);
        element === null || element === void 0 ? void 0 : element.removeEventListener('syContextConsumerDidSubscribe', this.__syContextProvidesListeningFunction);
      }
      return disconnectedCallbackReturn;
    };
  };
}
